export const environment = {
    production: false,
    apiUrl: 'https://gateway.dev.takenote.cloud/cc',
    productId: 'Global-Exchange-Demo',
    productType: 'GEN'
};